/**
* File and all contents are proprietary work of Executives On The Web Ltd
* and must not be copied or redistributed without express permission.
*
* functions used for loading component files into JS
*
* @since 20220314
* @author Thomas Higham <thomash@executivesontheweb.com>
*
* @copyright (c) 2022 Executives On The Web Ltd. All right Reserved.
*/
export default {
    loadComponents: function(components, onload=null){
        if(components !== undefined && components !== null && components.length > 0){
            var allLoaded = true;
            for(var i=0; i<components.length; i++){
                if(window.loadedScripts[this.getComponentNameFromURL(components[i])] === undefined){
                    allLoaded = false;
                    var script = document.createElement('script');
                    var self = this;
                    script.onload = function () {
                        if(onload !== null && self.componentsLoaded(components)){
                            onload();
                        }
                    };
                    script.src = components[i];
                    document.head.appendChild(script);
                }
            }
            if(onload !== null && allLoaded){
                onload();
            }
        } else if(onload !== null){
            onload();
        }
    },
    componentsLoaded: function(components){
        var allLoaded = true;
        if(components !== undefined && components !== null && components.length > 0){
            for(var i=0; i<components.length; i++){
                if(window.loadedScripts[this.getComponentNameFromURL(components[i])] === undefined){
                    allLoaded = false;
                }
            }
        }
        return allLoaded;
    },
    getComponentNameFromURL: function(component){
        var name = '';
        var dotSplit = component.split('.');
        var slashSplit = dotSplit[0].split('/');
        name = slashSplit[slashSplit.length-1];
        return name;
    },
    doThread: function(workFunc, data) {
        let b = new Blob(["onmessage =" + workFunc.toString()], {type: "text/javascript"});
        let worker = new Worker(URL.createObjectURL(b));
        worker.postMessage(data); 
        return new Promise(resolve => worker.onmessage = e => resolve(e.data));
      }
}